var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalenderFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_367_2581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.625 3.3125H3.375C3.06434 3.3125 2.8125 3.56434 2.8125 3.875V15.125C2.8125 15.4357 3.06434 15.6875 3.375 15.6875H14.625C14.9357 15.6875 15.1875 15.4357 15.1875 15.125V3.875C15.1875 3.56434 14.9357 3.3125 14.625 3.3125Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 2.1875V4.4375",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 2.1875V4.4375",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 6.6875H15.1875",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 6.6875H14.625C14.9357 6.6875 15.1875 6.87066 15.1875 7.09659V15.2784C15.1875 15.5043 14.9357 15.6875 14.625 15.6875H3.375C3.06434 15.6875 2.8125 15.5043 2.8125 15.2784V7.09659C2.8125 6.87066 3.06434 6.6875 3.375 6.6875ZM12.0616 10.0303C12.3545 9.73744 12.3545 9.26256 12.0616 8.96967C11.7687 8.67678 11.2938 8.67678 11.0009 8.96967L8.15625 11.8143L6.99908 10.6572C6.70619 10.3643 6.23131 10.3643 5.93842 10.6572C5.64553 10.9501 5.64553 11.4249 5.93842 11.7178L7.62592 13.4053C7.91881 13.6982 8.39369 13.6982 8.68658 13.4053L12.0616 10.0303Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_2581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderFrame);
export default __webpack_public_path__ + "static/media/calender-frame.879bea80.svg";
export { ForwardRef as ReactComponent };